import { getStopResumePosition } from '../../../../utils/stopResume'

export default function getCurrentEpisodeFromStore({ groupToken, includeNext = false }) {
  return new Promise((resolve, reject) => {
    const maxAttempts = 50 // Maximum number of attempts
    const interval = 100 // Interval between attempts in milliseconds
    let attempts = 0

    function checkStore() {
      attempts += 1
      const parentStore = window.parent.__NEXT_REDUX_STORE__

      if (parentStore) {
        const state = parentStore.getState()
        const episodeData = state.episode.currentEpisode
        const nextEpisodeData = state.episode.nextEpisode
        const recommendedProgrammeData = state.episode.recommendedProgramme

        if (episodeData) {
          const resumePosition = getStopResumePosition({ id: episodeData.episodeInfo.episodeId })
          const result = {
            resumePosition,
            duration: parseInt(episodeData.video.length, 10) || 0,
            isPlayerPlus: state.user.currentlySubscribed === true,
            drmEnabled: episodeData?.programme?.drmEnabled === true,
            id: episodeData.video.id,
            programmeName: episodeData.programme.name,
            playerApiRefId: episodeData.episodeInfo.episodeGuid,
            matId: episodeData.video.matId,
            groupToken,
          }

          if (includeNext) {
            if (nextEpisodeData) {
              result.nextEpisode = nextEpisodeData
            }
            if (recommendedProgrammeData) {
              result.recommendedProgramme = recommendedProgrammeData
            }
          }

          resolve(result)
        } else {
          reject(new Error('Episode data not found in Redux store'))
        }
      } else if (attempts < maxAttempts) {
        setTimeout(checkStore, interval)
      } else {
        reject(new Error('Parent Redux store not found after maximum attempts'))
      }
    }

    checkStore()
  })
}
